{
  "version": "1.2.6",
  "objects": {
    "7536295121000845848": {
      "type": "frame",
      "id": "7536295121000845848",
      "z": 11767,
      "textContent": "",
      "left": 4899.664863766533,
      "top": 1270.5960202092735,
      "width": 1110,
      "height": 625,
      "scaleX": 0.3894785405990349,
      "scaleY": 0.919775,
      "fill": "#FFFFFF",
      "opacity": 1,
      "notInNavigation": false,
      "componentName": "",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "children",
      "layoutSizeVertical": "children",
      "layoutGap": 50,
      "layoutPadding": 30,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7536295120990909178": {
      "type": "frame",
      "id": "7536295120990909178",
      "z": -1015,
      "textContent": "",
      "left": 4929.664863766533,
      "top": 1390.4553952092735,
      "width": 1110,
      "height": 625,
      "scaleX": 0.33542448654498086,
      "scaleY": 0.68,
      "fill": "#F5FBFF",
      "opacity": 1,
      "container": "7536295121000845848",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a15Xg",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "children",
      "layoutGap": 0,
      "layoutPadding": 30,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "top"
    },
    "7536295120996804800": {
      "type": "wireframe",
      "id": "7536295120996804800",
      "z": 11187,
      "top": 1755.4553952092735,
      "left": 4959.664863766533,
      "width": 419.9832367981011,
      "height": 40,
      "scaleX": 0.75,
      "scaleY": 0.75,
      "container": "7536295120990909178",
      "layoutPosition": "a11fF",
      "wireframeName": "button",
      "fill": "#0090FE",
      "textColor": null,
      "style": "roundFilled",
      "fontSize": 14,
      "label": {},
      "placeholder": { "state": "default", "value": "Upgrade" },
      "setDimension": true
    },
    "7536295120998530719": {
      "type": "frame",
      "id": "7536295120998530719",
      "z": 11447,
      "textContent": "",
      "left": 4959.664863766533,
      "top": 1632.4553952092735,
      "width": 1110,
      "height": 625,
      "scaleX": 0.2813704324909268,
      "scaleY": 0.1968,
      "fill": "transparent",
      "opacity": 1,
      "container": "7536295120990909178",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a01O3",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "children",
      "layoutGap": 5,
      "layoutPadding": 10,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "top"
    },
    "7536295120988333564": {
      "type": "frame",
      "id": "7536295120988333564",
      "z": 123,
      "textContent": "",
      "left": 4969.664863766533,
      "top": 1678.4553952092735,
      "width": 1110,
      "height": 625,
      "scaleX": 0.26335241447290875,
      "scaleY": 0.0496,
      "fill": "transparent",
      "opacity": 1,
      "container": "7536295120998530719",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a0hd9",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "children",
      "layoutGap": 5,
      "layoutPadding": 3,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "center"
    },
    "7536295120999785569": {
      "type": "shape",
      "id": "7536295120999785569",
      "z": 127,
      "shapeName": "text",
      "textContent": "<p>Second feature description</p>",
      "left": 4991.8533571316575,
      "top": 1681.4553952092735,
      "width": 176.16666666666669,
      "height": 29.166666666666668,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.8571428571428571,
      "scaleY": 0.8571428571428571,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 0.5,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 0.6,
      "textAlign": "left",
      "fontSize": 12,
      "angle": 0,
      "container": "7536295120988333564",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a10vF",
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7536295121002193462": {
      "type": "shape",
      "id": "7536295121002193462",
      "z": 131,
      "shapeName": "icon",
      "textContent": "",
      "left": 4972.664863766533,
      "top": 1686.8611485267113,
      "width": 100,
      "height": 100,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.13188493365124418,
      "scaleY": 0.13188493365124418,
      "stroke": "#333333",
      "strokeWidth": 1,
      "opacity": 0.6,
      "borderOpacity": 1,
      "fill": "transparent",
      "angle": 0,
      "container": "7536295120988333564",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a10gOImB",
      "maskType": "none",
      "iconName": "fas/phone",
      "locked": false
    },
    "7536295120993488353": {
      "type": "frame",
      "id": "7536295120993488353",
      "z": 135,
      "textContent": "",
      "left": 4969.664863766533,
      "top": 1642.4553952092735,
      "width": 1110,
      "height": 625,
      "scaleX": 0.26335241447290875,
      "scaleY": 0.0496,
      "fill": "transparent",
      "opacity": 1,
      "container": "7536295120998530719",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a05su",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "children",
      "layoutGap": 5,
      "layoutPadding": 3,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "center"
    },
    "7536295121003965316": {
      "type": "shape",
      "id": "7536295121003965316",
      "z": 139,
      "shapeName": "text",
      "textContent": "<p>First feature description</p>",
      "left": 4989.747710234895,
      "top": 1645.4553952092735,
      "width": 156.33333333333334,
      "height": 29.166666666666668,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.8571428571428571,
      "scaleY": 0.8571428571428571,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 0.5,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 0.6,
      "textAlign": "left",
      "fontSize": 12,
      "angle": 0,
      "container": "7536295120993488353",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a10vF",
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7536295120994487436": {
      "type": "shape",
      "id": "7536295120994487436",
      "z": 143,
      "shapeName": "icon",
      "textContent": "",
      "left": 4972.664863766533,
      "top": 1650.0668308970326,
      "width": 100,
      "height": 133.33333333333334,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.11082846468361418,
      "scaleY": 0.11082846468361418,
      "stroke": "#333333",
      "strokeWidth": 1,
      "opacity": 0.6,
      "borderOpacity": 1,
      "fill": "transparent",
      "angle": 0,
      "container": "7536295120993488353",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a10gOImB",
      "maskType": "none",
      "iconName": "fas/bolt-lightning",
      "locked": false
    },
    "7536295121003450163": {
      "type": "frame",
      "id": "7536295121003450163",
      "z": 147,
      "textContent": "",
      "left": 4969.664863766533,
      "top": 1714.4553952092735,
      "width": 1110,
      "height": 625,
      "scaleX": 0.26335241447290875,
      "scaleY": 0.0496,
      "fill": "transparent",
      "opacity": 1,
      "container": "7536295120998530719",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a10uI",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "children",
      "layoutGap": 5,
      "layoutPadding": 3,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "center"
    },
    "7536295120988675353": {
      "type": "shape",
      "id": "7536295120988675353",
      "z": 151,
      "shapeName": "text",
      "textContent": "<p>Third feature description</p>",
      "left": 4989.747710234895,
      "top": 1717.4553952092735,
      "width": 161,
      "height": 29.166666666666668,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.8571428571428571,
      "scaleY": 0.8571428571428571,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 0.5,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 0.6,
      "textAlign": "left",
      "fontSize": 12,
      "angle": 0,
      "container": "7536295121003450163",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a10vF",
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7536295120996140300": {
      "type": "shape",
      "id": "7536295120996140300",
      "z": 155,
      "shapeName": "icon",
      "textContent": "",
      "left": 4972.664863766533,
      "top": 1724.5296856677796,
      "width": 100,
      "height": 88.88888888888889,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.11082846468361418,
      "scaleY": 0.11082846468361418,
      "stroke": "#333333",
      "strokeWidth": 1,
      "opacity": 0.6,
      "borderOpacity": 1,
      "fill": "transparent",
      "angle": 0,
      "container": "7536295121003450163",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a10gOImB",
      "maskType": "none",
      "iconName": "fas/star",
      "locked": false
    },
    "7536295121002305412": {
      "type": "frame",
      "id": "7536295121002305412",
      "z": 11457,
      "textContent": "",
      "left": 4959.664863766533,
      "top": 1471.4553952092735,
      "width": 1110,
      "height": 625,
      "scaleX": 0.2813704324909268,
      "scaleY": 0.152,
      "fill": "transparent",
      "opacity": 1,
      "container": "7536295120990909178",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "Zz1GE",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "children",
      "layoutGap": 0,
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "center"
    },
    "7536295120995478655": {
      "type": "shape",
      "id": "7536295120995478655",
      "z": 103,
      "shapeName": "text",
      "textContent": "<p><span style=\"color:#B2B2B2\">$</span><strong>100</strong></p>",
      "left": 4959.664863766533,
      "top": 1471.4553952092735,
      "width": 41.22878932423091,
      "height": 29.672234740923763,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 3.201646280756083,
      "scaleY": 3.201646280756083,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 0.5,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 1,
      "textAlign": "left",
      "fontSize": 44.82304793058516,
      "angle": 0,
      "container": "7536295121002305412",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a48d3",
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7536295121000758219": {
      "type": "shape",
      "id": "7536295121000758219",
      "z": 107,
      "shapeName": "text",
      "textContent": "<p>USD /</p><p>month</p>",
      "left": 5091.664863766533,
      "top": 1497.9553952092735,
      "width": 49,
      "height": 49,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.8571428571428571,
      "scaleY": 0.8571428571428571,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 0.5,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 0.4,
      "textAlign": "left",
      "fontSize": 12,
      "angle": 0,
      "container": "7536295121002305412",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a50iL",
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7536295120990347122": {
      "type": "shape",
      "id": "7536295120990347122",
      "z": 11467,
      "shapeName": "text",
      "textContent": "<p>Plan description</p>",
      "left": 4959.664863766533,
      "top": 1566.4553952092735,
      "width": 109.66666666666667,
      "height": 29.166666666666668,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.8571428571428571,
      "scaleY": 0.8571428571428571,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 0.5,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 0.4,
      "textAlign": "left",
      "fontSize": 12,
      "angle": 0,
      "container": "7536295120990909178",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "ZzbONmQx",
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7536295120988950722": {
      "type": "shape",
      "id": "7536295120988950722",
      "z": 11477,
      "shapeName": "text",
      "textContent": "<p>Everything in your plan plus</p>",
      "left": 4959.664863766533,
      "top": 1611.4553952092735,
      "width": 182,
      "height": 29.4,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.7142857142857143,
      "scaleY": 0.7142857142857143,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 0.5,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 0.4,
      "textAlign": "left",
      "fontSize": 10,
      "angle": 0,
      "container": "7536295120990909178",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a01MWXMW",
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7536295120990021009": {
      "type": "frame",
      "id": "7536295120990021009",
      "z": 11487,
      "textContent": "",
      "left": 4959.664863766533,
      "top": 1420.4553952092735,
      "width": 1110,
      "height": 625,
      "scaleX": 0.2813704324909268,
      "scaleY": 0.0816,
      "fill": "transparent",
      "opacity": 1,
      "container": "7536295120990909178",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": null,
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "children",
      "layoutGap": "auto",
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7536295121003184451": {
      "type": "shape",
      "id": "7536295121003184451",
      "z": 81,
      "shapeName": "text",
      "textContent": "<p>Pro</p>",
      "left": 4959.664863766533,
      "top": 1420.4553952092735,
      "width": 31.5,
      "height": 29.75,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1.7142857142857142,
      "scaleY": 1.7142857142857142,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 0.5,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 1,
      "textAlign": "left",
      "fontSize": 24,
      "angle": 0,
      "container": "7536295120990021009",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": null,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7536295121002143675": {
      "type": "wireframe",
      "id": "7536295121002143675",
      "z": 82,
      "top": 1436.0578922680377,
      "left": 5180.121656140684,
      "width": 104.9306640625,
      "height": 22.859375,
      "scaleX": 0.8659469422270704,
      "scaleY": 0.8659469422270704,
      "container": "7536295120990021009",
      "layoutPosition": "Zz4GD",
      "wireframeName": "pill",
      "fill": "#0090FE",
      "textColor": "#333333",
      "style": "round",
      "fontSize": 14,
      "label": {},
      "placeholder": { "value": "Most popular" },
      "showBackground": true,
      "showOutline": false
    },
    "7536295121000598756": {
      "type": "frame",
      "id": "7536295121000598756",
      "z": 11497,
      "textContent": "",
      "left": 4959.664863766533,
      "top": 1591.4553952092735,
      "width": 1110,
      "height": 625,
      "scaleX": 0.2813704324909268,
      "scaleY": 0.032,
      "fill": "transparent",
      "opacity": 1,
      "container": "7536295120990909178",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "ZzcAD",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "children",
      "layoutGap": 0,
      "layoutPadding": 10,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "top"
    },
    "7536295120996462007": {
      "type": "wireframe",
      "id": "7536295120996462007",
      "z": 11167,
      "top": 1300.5960202092735,
      "left": 4952.547366557518,
      "width": 326.55617448295834,
      "height": 39.859375,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7536295121000845848",
      "layoutPosition": "a03oR",
      "wireframeName": "multiSelect",
      "fill": "#0073CF",
      "itemsData": {
        "7535187384111998472": {
          "id": "7535187384111998472",
          "value": "Free",
          "item_position": 0
        },
        "7535187384121836933": {
          "id": "7535187384121836933",
          "value": "Enterprise",
          "item_position": 2000000
        },
        "7535187384123080106": {
          "id": "7535187384123080106",
          "state": "selected",
          "value": "Pro",
          "item_position": 1000000
        }
      },
      "textColor": "#FFFFFF",
      "style": "round",
      "fontSize": 14,
      "label": {},
      "placeholder": {},
      "setDimension": true,
      "showIcons": false
    }
  }
}
